import { useState } from "react";
import { useSelector } from "react-redux";
import { defineMessages } from "react-intl";
import {
  FacebookShareButton,
  TwitterShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  EmailIcon
} from "react-share";
import classNames from "classnames";
import compact from "lodash/compact";

import { useFormatMessage } from "./Intl/Context";
import Button from "./Buttons/Button";
import Icon from "./Utils/Icon";

const ShareButtons = props => {
  const shareUrl = props.shareUrl || window.location.href;
  const title = props.title || document.getElementsByTagName("title")[0].innerHTML;
  const message = props.message;
  const emailMessage = compact([title, message, shareUrl]).join("\n");

  const [isOpen, setIsOpen] = useState(false);

  const className = classNames(
    "btn-group",
    "dropdown",
    "show",
    "btn-with-counter",
    props.className
  );
  const socialSharingEnabled = useSelector(({ styling }) => styling.socialSharingEnabled);

  const t = useFormatMessage();
  const dropdownTitle = t(intlMessages.dropdownTitle);
  const facebookLabel = t(intlMessages.facebookLabel);
  const facebookSrLabel = t(intlMessages.facebookSrLabel);
  const twitterLabel = t(intlMessages.twitterLabel);
  const twitterSrLabel = t(intlMessages.twitterSrLabel);
  const emailLabel = t(intlMessages.emailLabel);
  const emailSrLabel = t(intlMessages.emailSrLabel);
  const listLabel = t(intlMessages.listLabel);

  const caretIconClassName = classNames("fa", "margin-right-none", {
    "fa-caret-down": !isOpen,
    "fa-caret-up": isOpen
  });

  if (!socialSharingEnabled) return null;

  return (
    <div className={className}>
      <Button
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        id="share-buttons-link"
        className="btn btn-sm btn-primary-inverse"
        aria-expanded={isOpen}
      >
        <span className="with-icon">
          <Icon className="fa fa-share margin-right-xxs" />
          <Icon className={caretIconClassName} />
          <span className="sr-only">{listLabel}</span>
        </span>
      </Button>

      {isOpen && (
        <ul
          className="dropdown-menu dropdown-menu-end show"
          aria-labelledby="share-buttons-link"
        >
          <li className="dropdown-header">{dropdownTitle}</li>

          <li className="dropdown-item">
            <FacebookShareButton
              url={shareUrl}
              quote={title}
              className="share-facebook-button share-button d-flex align-items-center"
            >
              <FacebookIcon
                size={30}
                iconFillColor="black"
                bgStyle={{ fill: "none" }}
                aria-hidden
                focusable={false}
              />
              {facebookLabel}
              <span className="sr-only">{facebookSrLabel}</span>
            </FacebookShareButton>
          </li>

          <li className="dropdown-item">
            <TwitterShareButton
              url={shareUrl}
              title={title}
              className="share-twitter-button share-button d-flex align-items-center"
            >
              <TwitterIcon
                size={30}
                iconFillColor="black"
                bgStyle={{ fill: "none" }}
                aria-hidden
                focusable={false}
              />
              {twitterLabel}
              <span className="sr-only">{twitterSrLabel}</span>
            </TwitterShareButton>
          </li>

          <li className="dropdown-item">
            <EmailShareButton
              url={shareUrl}
              subject={title}
              body={emailMessage}
              openShareDialogOnClick={true}
              className="share-email-button share-button d-flex align-items-center"
            >
              <EmailIcon
                size={30}
                iconFillColor="black"
                bgStyle={{ fill: "none" }}
                aria-hidden
                focusable={false}
              />
              {emailLabel}
              <span className="sr-only">{emailSrLabel}</span>
            </EmailShareButton>
          </li>
        </ul>
      )}
    </div>
  );
};

export default ShareButtons;

const intlMessages = defineMessages({
  dropdownTitle: {
    id: "shareButtons.dropdownTitle",
    defaultMessage: "Partager via"
  },
  facebookLabel: {
    id: "shareButtons.facebookLabel",
    defaultMessage: "Facebook"
  },
  facebookSrLabel: {
    id: "shareButtons.facebookSrLabel",
    defaultMessage: "Partager la page sur Facebook"
  },
  twitterLabel: {
    id: "shareButtons.twitterLabel",
    defaultMessage: "Twitter"
  },
  twitterSrLabel: {
    id: "shareButtons.twitterSrLabel",
    defaultMessage: "Partager la page sur Twitter"
  },
  emailLabel: {
    id: "shareButtons.emailLabel",
    defaultMessage: "E-mail"
  },
  emailSrLabel: {
    id: "shareButtons.emailSrLabel",
    defaultMessage: "Partager la page par e-mail"
  },
  listLabel: {
    id: "shareButtons.listLabel",
    defaultMessage: "Partager la page"
  }
});
